import { Credentials } from "auth/modules/state";
import GraphiQL from "graphiql";
import "graphiql/graphiql.css";
import { BareLayout } from "layouts";
import React, { FC } from "react";

export interface AdminGraphProps {
    credentials: Credentials;
}

/** What GraphiQL hands its fetcher. */
export interface GraphQLParams {
    query: string;
    variables?: Record<string, unknown> | null;
    operationName?: string | null;
}

const AdminGraphView: FC<AdminGraphProps> = (props: AdminGraphProps) => {
    async function graphQLFetcher(graphQLParams: GraphQLParams): Promise<unknown> {
        const api = window.xaStudioConfig?.apiUrl;
        if (!api) {
            throw new Error("Studio config has no apiUrl, so there is no GraphQL endpoint to query.");
        }

        const response = await fetch(`${api}/graphql`, {
            body: JSON.stringify(graphQLParams),
            headers: {
                "Content-Type": "application/json",
                "x-xapp-usertoken": props.credentials.accessToken,
            },
            method: "post",
        });

        if (response.ok) {
            return response.json();
        }

        // A GraphQL server answers a bad query with a 4xx and an `errors` body; show those as-is.
        const body: unknown = await response.json().catch((): undefined => undefined);
        if (body && typeof body === "object" && "errors" in body) {
            return body;
        }
        throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
    }

    return (
        <BareLayout>
            <GraphiQL fetcher={graphQLFetcher} />
        </BareLayout>
    );
};

export { AdminGraphView };
